import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchPendingServiceEventList = ({commit}) => {
    axios.get('/serviceProviderPortal/fetchPendingServiceEventList.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')
        commit('setEventList', res.data.response)
    })
    .catch(error => {
        console.log(error)
        
    })

}

export const uploadEventMediaFile = ({dispatch}, payload) => {

    axios.post('/serviceProviderPortal/uploadEventMediaFile.php', payload)
    .then(res => {
        dispatch('fetchPendingServiceEventList')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const deleteEventMediaFile = ({dispatch}, payload) => {

    axios.post('/serviceProviderPortal/deleteEventMediaFile.php', payload)
    .then(res => {
        dispatch('fetchPendingServiceEventList')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const notifyEventMediaFile = ({dispatch}, payload) => {

    axios.post('/serviceProviderPortal/notifyEventMediaFile.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('fetchPendingServiceEventList')
    })
    .catch(error => {
        console.log(error)
                        
    })

}

export const updateEventMediaFileFolder = ({dispatch}, payload) => {

    axios.post('/serviceProviderPortal/updateEventMediaFileFolder.php', payload)
    .then(res => {
        console.log(JSON.stringify(res.data))
        dispatch('fetchPendingServiceEventList')
    })
    .catch(error => {
        console.log(error)
                        
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/events/actions.js